export default {
  updateTime: 15 * 60 * 1000,
  scoreTable: {
    total: 5,
  },
  rankings: {
    perPage: 16,
  },
};
